import React from "react";
import {Box} from "@reside/ui";

import {ButtonLink} from "../../../atoms/button-link";

type Props = Readonly<{
  facilityId: string;
}>;

export const ActivityLogHeader = ({facilityId}: Props) => (
  <Box
    flexDirection="row"
    alignItems="center"
    justifyContent="flex-end"
    marginBottom={24}
    className="pageadminfacilitysettings-btn-1"
  >
    <ButtonLink to={`/admin/facility/${facilityId}/facility-settings`}>
      Facility Settings
    </ButtonLink>
  </Box>
);
